import React from 'react'
import enzgraphics from '../images/employment-nz-graphics.png';
import enzlogo from '../images/enz-logo.png';
import styles from './JoinUnion.module.scss';

const TopHeader = () => {
  return (
    <div className={styles.header}>
        <div className="row">
            <div className="col-sm-4 text-left">
                <img className={styles.logo} src={enzlogo} alt="Employment New Zealand" />
                <div className={styles.tinyText}>Employment Relations Act 2000, s62A</div>
            </div>
            <div className="col-md-offset-4 col-sm-4 text-right">
                <img className={styles.graphicImage} src={enzgraphics} alt="header graphics" />
            </div>
        </div>
    </div>
  )
}

export default TopHeader;